import { customElement } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import Player from '@vimeo/player';

@customElement('product-gallery-video')
class ProductGalleryVideo extends LitElement {
  constructor() {
    super();
    this.player = null;
    this.isPlaying = false;
    this.mediaType = this.getAttribute('data-media-type');
    this.playButton = this.querySelector('[data-play-button]');
    this.pauseButton = this.querySelector('[data-pause-button]');

    if (this.mediaType === 'external_video') {
      this.initVimeoVideo();
    } else {
      this.initShopifyVideo();
    }
  }

  createRenderRoot() {
    return this;
  }

  initVimeoVideo = () => {
    this.videoElement = this.querySelector('iframe');
    this.player = new Player(this.videoElement, {
      controls: false,
      autoplay: true,
      background: true,
      muted: true,
      responsive: true,
      loop: true,
    });
    this.player.on('play', () => {
      const previewImage = this.querySelector('[data-preview-image]');
      if (previewImage) {
        setTimeout(() => {
          previewImage.classList.add('opacity-0');
        }, 300);
      }
    });

    this.player.setAutopause(false).catch((error) => {
      console.error(error);
    });
    this.bindEventListeners();
  };

  initShopifyVideo = () => {
    this.player = this.querySelector('video');
    this.bindEventListeners();
  };

  bindEventListeners = () => {
    this.playButton.addEventListener('click', this.playVideo);
    this.pauseButton.addEventListener('click', this.pauseVideo);
  };

  pauseVideo = () => {
    this.player.pause();
    this.isPlaying = false;
    this.pauseButton.classList.add('hidden');
    this.playButton.classList.remove('hidden');
  };

  playVideo = () => {
    this.player.play();
    this.isPlaying = true;
    this.playButton.classList.add('hidden');
    this.pauseButton.classList.remove('hidden');
  };

  render() {
    return html`<slot></slot>`;
  }
}

export default ProductGalleryVideo;
